import _ from 'lodash';
import { filterFeature, getDomainRange } from './VectorLayerUtils';

const HeatmapOverlay = require('heatmap.js/plugins/leaflet-heatmap/leaflet-heatmap.js');

export class HeatLayer {
    static create (options) {
        return new HeatmapOverlay({
            radius: options.controlRange || 30,
            blur: 0.6,
            minOpacity: 0.1,
            maxOpacity: 1,
            latField: 'y',
            lngField: 'x',
            valueField: 'z',
            gradient: (() => {
                try {
                    return options.symbology.heat.theme;
                } catch (err) {
                    console.log(err);
                    return {
                        1: '#d53e4f',
                        0.9: '#fdae61',
                        0.7: '#abdda4',
                        0.6: '#66c2a5',
                        0.4: '#3288bd'
                    };
                }
            })()
        });
    }

    static geoJsonToHeatLayer (data, options) {
        let range, max;

        const symbology = (() => {
            try {
                return (options.symbology.heat || {});
            } catch (err) {
                console.log(err);
                return {};
            }
        })();

        const { property } = symbology;

        const filtersOptions = {
            filter: options.filter,
            bounds: options.expandView ? options.map.getBounds().pad(options.expandView) : options.map.getBounds().pad(0.1),
        };

        const domain = _(data.features)
            .filter(x => x.properties[property] !== 0)
            .filter(f => {
                if (_.isFunction(symbology.ignore)) {
                    if (!symbology.ignore(f.properties[property]) && (!options.filter || filterFeature(f, filtersOptions))) {
                        return true;
                    }
                } else if (!options.filter || filterFeature(f, filtersOptions)) {
                    return true;
                }

                return false;
            })
            .map(f =>
                ({
                    y: f.geometry.coordinates[1], // Lat
                    x: f.geometry.coordinates[0], // Lng
                    z: property ? symbology.inverse ? (Number(f.properties[property]) || 0) * (-1) : Number(f.properties[property]) || 0 : 0
                })
            )
            .value();

        const getElevation = value => {
            let elevation = 0.4;

            if (symbology.scale && range) {
                elevation = Number((range(value)).toFixed(2));
            } else if (value > 0 && max > 0) {
                elevation = Number((value / max).toFixed(2));
            }

            return (elevation < 0.4 ? 0.4 : elevation) * 100;
        };

        if (symbology.scale) {
            range = getDomainRange(_.map(domain, f => f.z), {
                scale: symbology.scale,
                theme: [0, 0.4, 0.5, 0.6, 0.7, 0.9, 1],
                dualband: symbology.dualband
            });
            max = _(domain).map(f => getElevation(f.z)).max();
        } else {
            max = _(domain).map('z').max() || 100;
        }

        const heatLayer = HeatLayer.create(options);

        const dataSource = _.map(domain, f => {
            return {
                z: getElevation(f.z),
                y: f.y,
                x: f.x
            };
        });

        max = _(dataSource).map('z').max();

        heatLayer.setData({
            max: _.uniqBy(dataSource, v => v.z).length === 1 ? 100 : max,
            data: dataSource
        });

        return heatLayer;
    }
}



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/VectorLayer/HeatLayer.js